var _path, _ellipse, _rect, _path2, _path3, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 80,
    viewBox: "0 0 67 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 53.1328C30.6667 52.1328 34.9 50.7328 38.5 53.1328",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.5,
    cy: 76.6328,
    rx: 23.5,
    ry: 2.5,
    fill: "#F3F3F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 19.6328,
    width: 66,
    height: 10,
    rx: 1.5,
    fill: "#957DD4",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4361 58.7082L6.59023 29.6328H59.4272L55.4763 58.6057C55.2399 60.3399 53.7587 61.6328 52.0084 61.6328H14.8885C13.1776 61.6328 11.7174 60.3959 11.4361 58.7082Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3555 1.12938C33.1609 0.953109 32.863 0.957443 32.6736 1.13933L8.86038 24C8.94998 24.1923 9 24.4067 9 24.6329C9 25.4613 8.32843 26.1329 7.5 26.1329C6.67157 26.1329 6 25.4613 6 24.6329C6 23.8044 6.67157 23.1329 7.5 23.1329C7.737 23.1329 7.96118 23.1878 8.16046 23.2857L31.9811 0.417953C32.5494 -0.12764 33.4429 -0.140641 34.0268 0.388168L59.1787 23.1673C59.2822 23.1448 59.3897 23.1329 59.5 23.1329C60.3284 23.1329 61 23.8044 61 24.6329C61 25.4613 60.3284 26.1329 59.5 26.1329C58.6716 26.1329 58 25.4613 58 24.6329C58 24.2919 58.1138 23.9775 58.3054 23.7256L33.3555 1.12938Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 41.1328,
    r: 2,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 41.1328,
    r: 2,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty_table.20d657a80badcd18bf663bd9b8404be6.svg";
export { ForwardRef as ReactComponent };